import React, { FC } from 'react';
import styled from 'styled-components';
import { globalTheme } from '@clds/component-theme';
import { TextSkeleton } from '@cld/skeleton';

const { font, spacing } = globalTheme;

const LongerChipSkeleton = styled(TextSkeleton)`
  height: ${font.size.xs};
  width: 100px;
  margin-right: ${spacing.xs};
`;

const ShorterChipSkeleton = styled(TextSkeleton)`
  height: ${font.size.xs};
  width: 60px;
`;

export const ChipsSkeleton: FC<React.PropsWithChildren<{ isLoading: boolean }>> = ({ isLoading, children }) => (
  <>
    {isLoading ? (
      <>
        <LongerChipSkeleton isLoading />
        <ShorterChipSkeleton isLoading />
      </>
    ) : (
      children
    )}
  </>
);
